import { modal } from "../library/modal";

class ReviewMore {
    private contents: NodeListOf<HTMLElement> = document.querySelectorAll<HTMLElement>(".review-item__content");
    private ro?: ResizeObserver;
    private mos = new Map<HTMLElement, MutationObserver>();

    constructor() {
        // если скрипт подключён внизу — init() всё равно вызовется;
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", () => this.init());
        } else {
            this.init();
        }
    }

    private init(): void {
        this.contents = document.querySelectorAll<HTMLElement>(".review-item__content");
        this.checkAll();

        // реагируем на ресайз (шрифты, viewport)
        window.addEventListener("resize", () => this.checkAll(), { passive: true });

        // ResizeObserver — если браузер поддерживает (меняет высоту при адаптиве)
        if ("ResizeObserver" in window) {
            this.ro = new (window as any).ResizeObserver(() => this.checkAll());
            this.contents.forEach(c => this.ro!.observe(c));
        }

        // MutationObserver на случай, если текст подгружается/меняется
        this.contents.forEach(content => {
            const mo = new MutationObserver(() => this.updateOne(content));
            mo.observe(content, { childList: true, subtree: true, characterData: true });
            this.mos.set(content, mo);
        });
    }

    private checkAll(): void {
        this.contents.forEach(content => this.updateOne(content));
    }

    private updateOne(content: HTMLElement): void {
        // измеряем в следующем кадре — даём браузеру отрендерить стили/шрифты
        requestAnimationFrame(() => {
            const overflowing = this.isOverflowing(content);
            const wrapper = content.closest<HTMLElement>(".review-item__content-block");
            if (!wrapper) return;

            if (overflowing) {
                wrapper.classList.add("has-more");
                // один раз привязываем обработчик клика
                if (!wrapper.dataset.moreListener) {
                    wrapper.addEventListener("click", () => {
                        if (wrapper.classList.contains("has-more")) this.openModal(content);
                    });
                    wrapper.dataset.moreListener = "1";
                }
            } else {
                wrapper.classList.remove("has-more");
            }
        });
    }

    private isOverflowing(content: HTMLElement): boolean {
        // сравниваем полную высоту и видимую
        // используем Math.ceil — чтобы избежать дробных погрешностей
        return content.scrollHeight > Math.ceil(content.clientHeight);
    }

    private openModal(content: HTMLElement): void {
        const modalTextEl = document.getElementById("review-modal-text");
        const modalHeadEl = document.getElementById("review-modal-head");
        if (!modalTextEl || !modalHeadEl) return;

        modalTextEl.textContent = content.innerText.trim();

        const reviewItem = content.closest<HTMLElement>(".review-item");
        if (reviewItem) {
            const head = reviewItem.querySelector<HTMLElement>(".review-item__head");
            if (head) modalHeadEl.innerHTML = head.innerHTML;
        }

        modal.open("review-modal");
    }
}

export const reviewMore = new ReviewMore();
